import createIcon from '../../createIcon';

/**
 * @component @name PhoneLocked
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMDAwOSA1LjVWNC41QzIwLjAwMDkgMy40IDE5LjEwMDkgMi41IDE4LjAwMDkgMi41QzE2LjkwMDkgMi41IDE2LjAwMDkgMy40IDE2LjAwMDkgNC41VjUuNUgxNS4wMDA5VjEwLjVIMjEuMDAwOVY1LjVIMjAuMDAwOVpNMTkuMDAwOSA1LjVIMTcuMDAwOVY0LjVDMTcuMDAwOSAzLjk1IDE3LjQ1MDkgMy41IDE4LjAwMDkgMy41QzE4LjU1MDkgMy41IDE5LjAwMDkgMy45NSAxOS4wMDA5IDQuNVY1LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuNjMwOSAxNC45TDEzLjExMDkgMTcuNEMxMC42MTA5IDE1Ljk3IDguNTQwODcgMTMuOSA3LjExMDg3IDExLjRMOS42MTA4NyA4Ljg4QzkuODQwODcgOC42NCA5Ljk0MDg3IDguMzEgOS44ODA4NyA3Ljk4TDkuMTMwODcgNC4zQzkuMDQwODcgMy44NCA4LjYzMDg3IDMuNSA4LjE1MDg3IDMuNUg0LjAwMDg3QzMuNDQwODcgMy41IDIuOTcwODcgMy45NyAzLjAwMDg3IDQuNTNDMy4xNzA4NyA3LjQyIDQuMDUwODcgMTAuMTMgNS40MzA4NyAxMi41QzcuMDEwODcgMTUuMjMgOS4yODA4NyAxNy40OSAxMi4wMDA5IDE5LjA3QzE0LjM3MDkgMjAuNDQgMTcuMDgwOSAyMS4zMyAxOS45NzA5IDIxLjVDMjAuNTMwOSAyMS41MyAyMS4wMDA5IDIxLjA2IDIxLjAwMDkgMjAuNVYxNi4zNUMyMS4wMDA5IDE1Ljg3IDIwLjY2MDkgMTUuNDYgMjAuMjAwOSAxNS4zN0wxNi41MzA5IDE0LjY0QzE2LjIwMDkgMTQuNTcgMTUuODYwOSAxNC42NyAxNS42MzA5IDE0LjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneLocked = createIcon('PhoneLocked', [
  [
    'path',
    {
      d: 'M20.0009 5.5V4.5C20.0009 3.4 19.1009 2.5 18.0009 2.5C16.9009 2.5 16.0009 3.4 16.0009 4.5V5.5H15.0009V10.5H21.0009V5.5H20.0009ZM19.0009 5.5H17.0009V4.5C17.0009 3.95 17.4509 3.5 18.0009 3.5C18.5509 3.5 19.0009 3.95 19.0009 4.5V5.5Z',
      key: '1qt50d',
    },
  ],
  [
    'path',
    {
      d: 'M15.6309 14.9L13.1109 17.4C10.6109 15.97 8.54087 13.9 7.11087 11.4L9.61087 8.88C9.84087 8.64 9.94087 8.31 9.88087 7.98L9.13087 4.3C9.04087 3.84 8.63087 3.5 8.15087 3.5H4.00087C3.44087 3.5 2.97087 3.97 3.00087 4.53C3.17087 7.42 4.05087 10.13 5.43087 12.5C7.01087 15.23 9.28087 17.49 12.0009 19.07C14.3709 20.44 17.0809 21.33 19.9709 21.5C20.5309 21.53 21.0009 21.06 21.0009 20.5V16.35C21.0009 15.87 20.6609 15.46 20.2009 15.37L16.5309 14.64C16.2009 14.57 15.8609 14.67 15.6309 14.9Z',
      key: '2fcpzj',
    },
  ],
]);

export default PhoneLocked;
